<template>
  <div class="about-us-slider">
    <h2 class="about-us-slider__title">
      Отзывы о нас
    </h2>
    <div class="about-us-slider__content">
      <Swiper
        v-bind="sliderParams"
      >
        <SwiperSlide v-for="item in 2">
          <AboutUsSliderItem />
        </SwiperSlide>
      </Swiper>
      <div class="about-us-slider__btns">
        <button class="swiper-button-prev" ref="btnPrev" aria-label="previous slide">
          <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
          </svg>
        </button>
        <button class="swiper-button-next" ref="btnNext" aria-label="next slide">
          <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, reactive} from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default {
  name: 'AboutUsSlider',
  props: ['result'],
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {

    const btnNext = ref(null);
    const btnPrev = ref(null);

    const sliderParams = reactive({
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
        prevEl: btnPrev,
        nextEl: btnNext,
      },
      spaceBetween: 30,
    })

    return {
      sliderParams,
      btnNext,
      btnPrev,
    }
  }
}
</script>

<style lang="scss" scoped>
.about-us-slider {
  margin-bottom: 35px;
  @include tablet{
    margin-bottom: 25px;
  }
  @include mobile{
    margin-bottom: 21px;
  }

  &__title {
    margin-top: 0;
    margin-bottom: 35px;
    @include tablet{
      margin-bottom: 18px;
    }
    @include mobile{
      margin-bottom: 16px;
    }
  }
  &__content{
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
  }
  &__btns{
    display: grid;
    grid-template-columns: repeat(2, 50px);
    grid-column-gap: 21px;
    position: absolute;
    bottom: 75px;
    left: 88px;
    @include tablet{
      grid-template-columns: repeat(2, 30px);
      grid-column-gap: 11px;
      bottom: 42px;
      left: 34px;
    }
    @include mobile{
      bottom: 29px;
      left: 25px;
    }
  }
  .swiper-button-next,
  .swiper-button-prev{
    position: static;
  }
}
</style>